import { createFileRoute, Navigate } from '@tanstack/react-router';
import { pageTitle } from '@/utils/pageTitle';
import { SellLedgerTable } from '@/components/Pages/Ledgers/SellLedgerTable';
import { Box } from '@mui/joy';
import { useAuth } from '@/contexts/AuthContext';

export const Route = createFileRoute('/_protected/ledgers/sells/')({
  component: SellLedgersPage,
  head: () => pageTitle('Cobros'),
});

function SellLedgersPage() {
  const { hasClaim, isLoading } = useAuth();
  const canRead = hasClaim('SELLS_READ');

  if (!isLoading && !canRead) {
    return <Navigate to='/' />;
  }

  return (
    <Box>
      <SellLedgerTable
        emptyMessage='No hay ventas registradas'
        errorTitle='Error al cargar las ventas'
      />
    </Box>
  );
}
